import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

const namespace = 'features';
export const keyPrefix = 'move_lists_to_department';

export const useMoveListsToDepartmentTranslation = (): UseTranslationResponse<typeof namespace, typeof keyPrefix> => {
  return useTranslation(namespace, { keyPrefix });
};

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    dropdown_item: 'Передать подразделению',
    title: 'Передать список',
    description: 'Список будет передан новому подразделению — владельцу',
    fields: {
      department: 'Кому передать',
      department_placeholder: 'Выберите подразделение',
      department_empty: 'Подразделения не найдены',
      keep_view_permission: 'Сохранить право на просмотр списка после передачи новому владельцу',
    },
    validation: {
      department_required: 'Поле обязательно для заполнения',
    },
    submit: 'Передать',
    cancel: 'Отмена',
    toast_success: 'Список успешно передан',
    toast_error: 'Не удалось передать список',
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    dropdown_item: 'Transfer to department',
    title: 'Transfer list',
    description: 'The list will be transferred to the new owner department',
    fields: {
      department: 'Transfer to',
      department_placeholder: 'Select department',
      department_empty: 'No departments found',
      keep_view_permission: 'Keep permission to view the list after transfer to the new owner',
    },
    validation: {
      department_required: 'This field is required',
    },
    submit: 'Transfer',
    cancel: 'Cancel',
    toast_success: 'List successfully transferred',
    toast_error: 'Failed to transfer list',
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    dropdown_item: 'Transferir para departamento',
    title: 'Transferir lista',
    description: 'A lista sera transferida para o novo departamento proprietario',
    fields: {
      department: 'Transferir para',
      department_placeholder: 'Selecione o departamento',
      department_empty: 'Nenhum departamento encontrado',
      keep_view_permission: 'Manter permissao para visualizar a lista apos transferir para o novo proprietario',
    },
    validation: {
      department_required: 'Este campo é obrigatório',
    },
    submit: 'Transferir',
    cancel: 'Cancelar',
    toast_success: 'Lista transferida com sucesso',
    toast_error: 'Falha ao transferir lista',
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    dropdown_item: 'Transferir al departamento',
    title: 'Transferir lista',
    description: 'La lista se transferira al nuevo departamento propietario',
    fields: {
      department: 'Transferir a',
      department_placeholder: 'Seleccionar departamento',
      department_empty: 'No se encontraron departamentos',
      keep_view_permission: 'Mantener permiso para ver la lista despues de transferirla al nuevo propietario',
    },
    validation: {
      department_required: 'Este campo es obligatorio',
    },
    submit: 'Transferir',
    cancel: 'Cancelar',
    toast_success: 'Lista transferida correctamente',
    toast_error: 'No se pudo transferir la lista',
  },
}) : {}) as Record<string, unknown>;
